// src/services/notificationService.js

const BASE_URL = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => {
  const studentToken = localStorage.getItem("studentToken");
  const staffToken = localStorage.getItem("token");

  const token = studentToken || staffToken;

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

/**
 * GET /mappedstudents/student/notifications
 * Returns list of notifications for the logged-in student
 */
export const getStudentNotifications = async () => {
  const response = await fetch(`${BASE_URL}/mappedstudents/student/notifications`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error("Failed to fetch notifications");
  return response.json();
};

/**
 * GET /student/mapped/:mappingId
 * Returns full company + placement details for a mapping
 */
export const getStudentCompanyFullDetails = async (mappingId) => {
  const response = await fetch(`${BASE_URL}/student/mapped/${mappingId}`, {
    headers: getAuthHeaders(),
  });
  if (!response.ok) throw new Error("Failed to fetch company details");
  return response.json();
};

/**
 * PUT /mappedstudents/:mappingId/acknowledge
 * Accept or Reject a mapping
 * @param {number} mappingId
 * @param {"Accepted"|"Rejected"} acknowledgementStatus
 * @param {string|null} acknowledgementFeedback - required if Rejected
 */
export const acknowledgeMapping = async (
  mappingId,
  acknowledgementStatus,
  acknowledgementFeedback = null
) => {
  const body = { acknowledgementStatus };
  if (acknowledgementStatus === "Rejected") {
    body.acknowledgementFeedback = acknowledgementFeedback;
  }

  const response = await fetch(
    `${BASE_URL}/mappedstudents/${mappingId}/acknowledge`,
    {
      method: "PUT",
      headers: getAuthHeaders(),
      body: JSON.stringify(body),
    }
  );
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || "Acknowledgement failed");
  }
  return response.json();
};